webpackJsonp([25],{

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _JPGToPDFLandingPageFreeWriteBackgroundLayout = __webpack_require__(1484);

var _JPGToPDFLandingPageFreeWriteBackgroundLayout2 = _interopRequireDefault(_JPGToPDFLandingPageFreeWriteBackgroundLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPGToPDFLandingPage = function (_React$PureComponent) {
  _inherits(JPGToPDFLandingPage, _React$PureComponent);

  function JPGToPDFLandingPage() {
    _classCallCheck(this, JPGToPDFLandingPage);

    return _possibleConstructorReturn(this, (JPGToPDFLandingPage.__proto__ || Object.getPrototypeOf(JPGToPDFLandingPage)).apply(this, arguments));
  }

  _createClass(JPGToPDFLandingPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.Upload.activateUploadButtonById('uploadPDFLarge');

      // Allow users to upload photos
      window.Upload.photoToPDF.init();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_JPGToPDFLandingPageFreeWriteBackgroundLayout2.default, { ctaId: 'uploadPDFLarge' });
    }
  }]);

  return JPGToPDFLandingPage;
}(_react2.default.PureComponent);

exports.default = (0, _WithInit2.default)(JPGToPDFLandingPage);

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _JPGToPDFLandingPage = __webpack_require__(1230);

var _JPGToPDFLandingPage2 = _interopRequireDefault(_JPGToPDFLandingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.JPGToPDFLandingPage = _JPGToPDFLandingPage2.default;

/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _JPGToPDFLandingPageFullWidthUploadPanel = __webpack_require__(1485);

var _JPGToPDFLandingPageFullWidthUploadPanel2 = _interopRequireDefault(_JPGToPDFLandingPageFullWidthUploadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPGToPDFLandingPageFreeWriteBackgroundLayout = function JPGToPDFLandingPageFreeWriteBackgroundLayout(props) {
  var jpgToPdfContainerClasses = (0, _classnames2.default)('jpg-to-pdf-container', 'large-upload-panel-mock-freewrite-wrapper', 'large-upload-panel-wrapper');
  return _react2.default.createElement(
    'div',
    { className: jpgToPdfContainerClasses },
    _react2.default.createElement('img', {
      src: '/images/jpg-pdf-toolbar-web.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-lg'
    }),
    _react2.default.createElement('img', {
      src: '/images/jpg-pdf-toolbar-mobile.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-xs'
    }),
    _react2.default.createElement(_JPGToPDFLandingPageFullWidthUploadPanel2.default, {
      ctaId: props.ctaId,
      subHeader: 'And explore our whole selection of editing tools.'
    })
  );
};

JPGToPDFLandingPageFreeWriteBackgroundLayout.propTypes = {
  ctaId: _propTypes2.default.string.isRequired
};

exports.default = JPGToPDFLandingPageFreeWriteBackgroundLayout;

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LandingPageFullWidthUploadPanelCTA = __webpack_require__(442);

var _LandingPageFullWidthUploadPanelCTA2 = _interopRequireDefault(_LandingPageFullWidthUploadPanelCTA);

var _LandingPagePhotoToPDFModal = __webpack_require__(443);

var _LandingPagePhotoToPDFModal2 = _interopRequireDefault(_LandingPagePhotoToPDFModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPGToPDFLandingPageFullWidthUploadPanel = function (_React$PureComponent) {
  _inherits(JPGToPDFLandingPageFullWidthUploadPanel, _React$PureComponent);

  function JPGToPDFLandingPageFullWidthUploadPanel() {
    _classCallCheck(this, JPGToPDFLandingPageFullWidthUploadPanel);

    return _possibleConstructorReturn(this, (JPGToPDFLandingPageFullWidthUploadPanel.__proto__ || Object.getPrototypeOf(JPGToPDFLandingPageFullWidthUploadPanel)).apply(this, arguments));
  }

  _createClass(JPGToPDFLandingPageFullWidthUploadPanel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-upload-section-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
          _react2.default.createElement(
            'form',
            { className: 'uploader' },
            _react2.default.createElement(
              'div',
              { className: 'alert alert-error uploader-error' },
              'Error'
            ),
            _react2.default.createElement(
              'div',
              { className: 'uploader-area edit-pages-uploader-area' },
              _react2.default.createElement('img', {
                src: '/images/icon-jpg-to-pdf.png',
                alt: 'JPG to PDF Icon',
                className: 'large-upload-panel-jpg-to-pdf-icon'
              }),
              _react2.default.createElement(
                'h3',
                { className: 'large-upload-panel-header' },
                'Convert Your Images to a PDF'
              ),
              _react2.default.createElement(
                'p',
                { className: 'large-upload-panel-sub-header' },
                this.props.subHeader
              ),
              _react2.default.createElement(_LandingPageFullWidthUploadPanelCTA2.default, {
                ctaId: this.props.ctaId,
                ctaText: 'Upload an Image to Convert',
                ctaOnClick: function ctaOnClick() {}
              })
            )
          )
        ),
        _react2.default.createElement(_LandingPagePhotoToPDFModal2.default, null)
      );
    }
  }]);

  return JPGToPDFLandingPageFullWidthUploadPanel;
}(_react2.default.PureComponent);

JPGToPDFLandingPageFullWidthUploadPanel.defaultProps = {
  subHeader: 'JPG or PDF'
};

JPGToPDFLandingPageFullWidthUploadPanel.propTypes = {
  ctaId: _propTypes2.default.string.isRequired,
  subHeader: _propTypes2.default.string
};

exports.default = JPGToPDFLandingPageFullWidthUploadPanel;

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingPageFullWidthUploadPanelCTA = function LandingPageFullWidthUploadPanelCTA(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'large-upload-panel-cta-wrapper',
      id: props.ctaId,
      onClick: props.ctaOnClick
    },
    _react2.default.createElement(
      _Buttons.PrimaryButton,
      { className: 'large-upload-panel-cta-button', onClick: function onClick() {} },
      props.ctaText
    )
  );
};

LandingPageFullWidthUploadPanelCTA.defaultProps = {
  ctaOnClick: function ctaOnClick() {},
  ctaText: ''
};

LandingPageFullWidthUploadPanelCTA.propTypes = {
  ctaId: _propTypes2.default.string.isRequired,
  ctaOnClick: _propTypes2.default.func,
  ctaText: _propTypes2.default.string
};

exports.default = LandingPageFullWidthUploadPanelCTA;

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LandingPagePhotoToPDFModal = function (_React$PureComponent) {
  _inherits(LandingPagePhotoToPDFModal, _React$PureComponent);

  function LandingPagePhotoToPDFModal() {
    _classCallCheck(this, LandingPagePhotoToPDFModal);

    return _possibleConstructorReturn(this, (LandingPagePhotoToPDFModal.__proto__ || Object.getPrototypeOf(LandingPagePhotoToPDFModal)).apply(this, arguments));
  }

  _createClass(LandingPagePhotoToPDFModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'photoToPDF', className: 'hidden centered photoToPDF' },
        _react2.default.createElement(
          'div',
          { className: 'image-upload-heading-container' },
          _react2.default.createElement(
            'p',
            { className: 'image-upload-text' },
            'Rearrange, Add, Delete Images'
          ),
          _react2.default.createElement(
            'div',
            { className: 'image-upload-buttons-container' },
            _react2.default.createElement(
              'div',
              { id: 'addImages-btn', className: 'addImages-btn ds-btn-secondary sm dark' },
              'Add Images',
              _react2.default.createElement('input', {
                type: 'file',
                accept: 'application/msword,\n                  application/vnd.openxmlformats-officedocument.wordprocessingml.document\n                  application/pdf,\n                  image/*',
                id: 'selectPhotos',
                name: 'files[]',
                multiple: true
              })
            ),
            _react2.default.createElement(
              _Buttons.PrimaryButton,
              { onClick: LandingPagePhotoToPDFModal.createPDF, size: 'sm' },
              _react2.default.createElement(
                'span',
                null,
                'Create PDF'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'photo-wrapper' },
          _react2.default.createElement('ul', { id: 'photoList' })
        )
      );
    }
  }], [{
    key: 'createPDF',
    value: function createPDF() {
      window.Upload.photoToPDF.createPDF();
      window._track('create-pdf-from-image', 'edit-pdf page');
    }
  }]);

  return LandingPagePhotoToPDFModal;
}(_react2.default.PureComponent);

exports.default = LandingPagePhotoToPDFModal;

/***/ })

},[1324]);


// WEBPACK FOOTER //
// jpg-to-pdf-landing-page.js